import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  h1 {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.3rem;
    margin: 0;
    font-weight: 500;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 10px;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  max-height: 60vh;
`;
